import type { AssetTypeTemplateEditProps } from "./asset-type-template-edit.type";

import { useTranslation } from "react-i18next";

import { useUpdateEntityTemplate } from "@/entities/entity-template";
import AssetTypeTemplateForm from "@/modules/asset-type-template/asset-type-template-form";

export const AssetTypeTemplateEdit = ({
  template,
}: AssetTypeTemplateEditProps) => {
  const { t } = useTranslation();

  const mutation = useUpdateEntityTemplate(template.id);

  return (
    <AssetTypeTemplateForm
      mutation={mutation}
      saveButtonLabel={t("global:update")}
      initialValues={template}
    />
  );
};
